import { couriersNode } from '@/api/firebase'
import { CourCtn } from '@/api/connections'
import { firebaseObjectWithId } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'

const COURIER_CONNECTION = CourCtn

const state = {
    courier: false,
    ...async()
}

const getters = {
    GET_COURIER: (state) => firebaseObjectWithId(state.courier),
    GET_ASYNC
}

const mutations = {
    SET_COURIER(state, payload) {
        state.courier = payload
    },
    CLEAR_COURIER(state) {
        state.courier = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_COURIER_BY_ID
     *
     *     Retrieve a courier by id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the courier provide to retrieve.
     * @returns {Void}
     */
    async FETCH_COURIER_BY_ID({ commit, dispatch }, payload) {
        await dispatch('REMOVE_COURIER_REFERENCE')
        commit('REQUEST')
        try {
            COURIER_CONNECTION.on('value', (data) => {
                commit('SET_COURIER', data || false)
            })
            COURIER_CONNECTION.initValue([payload.id])
            commit('SUCCESS')
        } catch (err) {
            commit('ERROR', err.message)
        }
    },

    /**
     * FETCH_COURIER_NAME_ONCE
     *
     *     Retrieve a the name of a courier.
     *     If empty, return null. Does not bind a firebase connection.
     *
     * @param payload.id {string} - The id of the courier to fetch.
     * @returns {String}
     */
    async FETCH_COURIER_NAME_ONCE(_, payload) {
        const data = await couriersNode
            .child(payload.id)
            .child('name')
            .once('value')
        return data.val()
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_COURIER_REFERENCE
     *
     *     Unbind a firebase connection that was set on a courier child.
     *
     * @param payload.id {string} - The id of the courier.
     */
    REMOVE_COURIER_REFERENCE({ commit }) {
        commit('CLEAR')
        commit('CLEAR_COURIER')
        COURIER_CONNECTION.removeAllListeners()
        COURIER_CONNECTION.closeValue()
    }
}

export { state, getters, mutations, actions }
